import React from "react";
import T from "prop-types";
import { StatusTag } from "MODULES/shared/components";

function ExchangeAgreementHold({ salesOrder }) {
  const hold = salesOrder.get("exchange_agreement_hold");

  if (hold) {
    return (
      <StatusTag
        display="warning"
        title="Awaiting Exchange Agreement"
        icon="pause"
      />
    );
  }

  return null;
}

ExchangeAgreementHold.propTypes = {
  salesOrder: T.shape({
    get: T.func.isRequired
  }).isRequired
};

export default ExchangeAgreementHold;



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Warnings/ExchangeAgreement.jsx